import React from 'react';

function Header({ user, onLoginClick, onLogoutClick }) {
  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <h1 className="header-title">크몽 자동 답변 시스템</h1>
        </div>
        <div className="header-right">
          {user ? (
            <div className="user-info">
              <span className="user-email">{user.email}</span>
              <button className="btn btn-secondary" onClick={onLogoutClick}>
                로그아웃
              </button>
            </div>
          ) : (
            <button className="btn btn-primary" onClick={onLoginClick}>
              로그인
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
